export default __webpack_public_path__ + "static/media/hht2_ep14_timeline_q02_b.1ad0ceb2.png";